import React, { useState } from "react";
import "./login.scss";
import { useFormik } from "formik";
import * as yup from "yup";
import UserService from "../../services/user";
import Toast from "../../components/toast/Toast";
import { useNavigate } from "react-router-dom";

const validationSchema = yup.object({
  email: yup.string("Enter email").email().required("Email is required"),
  password: yup.string("Enter password").required("Password is required"),
});

function Login() {
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMsg, setToastMsg] = useState("");
  const [toastStatus, setToastStatus] = useState("");
  const [user, setUser] = useState("admin");

  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      console.log(values);
      try {
        if (user === "admin") {
          var { data } = await UserService.adminLogin(values);
        } else {
          var { data } = await UserService.superAdminLogin(values);
        }
        if (data.token) {
          setToastOpen(true);
          setToastMsg("Login successfully");
          setToastStatus("success");
          localStorage.setItem("token", data.token);
          navigate("/dashboard");
        }
      } catch (err) {
        setToastOpen(true);
        setToastMsg("Please check your credential!");
        setToastStatus("error");
      }
    },
  });

  return (
    <div className="loginContainer">
      <div className="forms-container">
        <div className="signin-signup">
          <form
            className="sign-in-form loginForm"
            onSubmit={formik.handleSubmit}
          >
            <img
              className="logo-m"
              src="/shaagird-logo.svg"
              alt="Shaagird logo"
            />
            <h2 className="title">Sign in</h2>
            <div className="admin-role-row">
              <label className="admin-role-option">
                <input
                  type="radio"
                  name="loginRole"
                  value="admin"
                  checked={user === "admin"}
                  onChange={(e) => setUser(e.target.value)}
                />
                <span>Admin</span>
              </label>
              <label className="admin-role-option">
                <input
                  type="radio"
                  name="loginRole"
                  value="superAdmin"
                  checked={user === "superAdmin"}
                  onChange={(e) => setUser(e.target.value)}
                />
                <span>Super Admin</span>
              </label>
            </div>

            <div className="input-field">
              <span className="iLogin">&#9993;</span>
              <input
                className="LoginInput"
                id="email"
                name="email"
                type="email"
                placeholder="Email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
            {formik.touched.email && formik.errors.email && (
              <span className="login-error">{formik.errors.email}</span>
            )}

            <div className="input-field">
              <span className="iLogin">&#128274;</span>
              <input
                className="LoginInput"
                id="password"
                name="password"
                type="password"
                placeholder="Password"
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
            {formik.touched.password && formik.errors.password && (
              <span className="login-error">{formik.errors.password}</span>
            )}

            <button type="submit" className="btn btn-primary">
              Login
            </button>
          </form>
        </div>
      </div>

      <div className="panels-container">
        <div className="panel left-panel">
          <img className="image" src="/shaagird-logo.svg" alt="Shaagird logo" />
          <div className="contentLogin">
            <h3 className="loginh3">Welcome to Admin</h3>
            <p className="loginp">
              Supercharge your operations with secure and fast dashboards.
            </p>
            <button className="btn transparent" type="button">
              Manage now
            </button>
          </div>
        </div>
        <div className="panel right-panel">
          <img className="image" src="/shaagird-logo.svg" alt="Shaagird logo" />
          <div className="contentLogin">
            <h3 className="loginh3">Support & guidance</h3>
            <p className="loginp">
              Your school management workspace is always one login away.
            </p>
            <button className="btn transparent" type="button">
              Contact support
            </button>
          </div>
        </div>
      </div>
      {toastOpen && (
        <Toast
          toastOpen={toastOpen}
          toastClose={() => setToastOpen(false)}
          toastMsg={toastMsg}
          toastStatus={toastStatus}
        />
      )}
    </div>
  );
}

export default Login;
